import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import {
  h5Styles,
  smallcapsBold13Styles,
  smallcapsRegular13Styles,
} from "@constants/typography"
import { Cameron } from "@components/icons"

export const Headers = styled.div`
  display: flex;
  height: 72px;
  padding: 0 20px;
  align-items: center;
  border-bottom: solid 1px ${colors.dividerLineGray};

  @media ${breakpoints.laptop} {
    height: auto;
    padding: 108px calc(0.5 / 12 * 100vw) 64px;
    border: none;
  }
`

export const DesktopHeader = styled.div`
  display: none;

  @media ${breakpoints.laptop} {
    ${h5Styles}
    display: block;
    padding: 0 0 36px calc(0.5 / 12 * 100vw);
  }
`

export const DesktopDivider = styled.div`
  display: none;

  @media ${breakpoints.laptop} {
    display: block;
    width: 100%;
    height: 1px;
    padding: 0 calc(0.5 / 12 * 100vw - 16px);
    background-color: ${colors.dividerLineGray};
  }
`

const baseBreadcrumbTextStyles = `
  ${smallcapsRegular13Styles}
  font-size: 11px;
  color: ${colors.mediumDarkGray};
  line-height: 19px;
  letter-spacing: 1px;
`

const BreadcrumbContainer = styled.button`
  display: flex;
  padding: 0 16px 0 2px;
  align-items: center;
  transform: translateX(-16px);
  background-color: transparent;
  border: none;

  @media ${breakpoints.laptop} {
    height: 32px;
    transform: none;
    transition: background-color ${animation.medium} ${cubicBezier};
    background-color: transparent;
    border: 1px solid ${colors.dividerLineGray};
    border-radius: 2px;

    &:hover {
      transition: background-color ${animation.quick} ${cubicBezier};
      background-color: ${colors.dividerLineGray};
      cursor: pointer;
    }
  }
`

const BreadcrumbIcon = styled.div`
  width: 24px;
  height: 24px;
  transform: rotate(180deg);
`

export const BreadcrumbText = styled.span`
  ${smallcapsBold13Styles};
  margin-left: 2px;
  padding-top: 4px;

  @media ${breakpoints.laptop} {
    ${baseBreadcrumbTextStyles}
    display: flex;
    padding-top: 3px;
  }
`

export const BreadcrumbButton: React.FC<{
  label: string
  onClick?: any
}> = ({ label, onClick }) => (
  <BreadcrumbContainer onClick={onClick}>
    <BreadcrumbIcon>
      <Cameron />
    </BreadcrumbIcon>
    <BreadcrumbText>{label}</BreadcrumbText>
  </BreadcrumbContainer>
)

export const CurrentBreadcrumb = styled.div`
  ${baseBreadcrumbTextStyles}
  display: flex;
  height: 32px;
  margin-left: 26px;
  align-items: center;
  color: ${colors.mediumGray};
  opacity: 0.5;
`
